export default {
  head_scripts: {
    title: 'Skrypty nagłówka',
  },
  body_noscripts: {
    title: 'Noscript treści',
    description: 'Wstaw kod bezpośrednio po otwarciu body',
  },
  google_site_verification: {
    title: 'Weryfikacja witryny Google',
    label: 'Kod weryfikacji witryny Google',
  },
  buttons: {
    save: 'Zapisz',
  },
};
